var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"tn-copyable"},[_c('code',[_vm._v(_vm._s(_vm.value || '—'))]),(_vm.value)?_c('v-btn',{attrs:{"icon":"","x-small":"","aria-label":'Copy ' + _vm.label},on:{"click":_vm.copy}},[_c('v-icon',{attrs:{"size":"16"}},[_vm._v("mdi-content-copy")])],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }